import "./src/styles/fonts.css";
import "./src/styles/icons.css";
import "./src/styles/global.css";
import "react-phone-input-2/lib/style.css";
import "./src/styles/phoneStyles.css";
import "rc-slider/assets/index.css";
import "./src/styles/rsSliderStyles.css";

interface LocationState {
  preserveScroll?: boolean;
}

export const onRouteUpdate = ({
  location,
}: {
  location: { state: LocationState };
}) => {
  if (window.location.href.includes("#") || location.state?.preserveScroll) {
    return;
  }

  window.scrollTo({ top: 0, behavior: "instant" });
};

export const shouldUpdateScroll = ({ routerProps: { location } }: {routerProps: {location: {state: LocationState}}}) => {
  return !location.state?.preserveScroll;
};
